var map = {
	"./Formatted_CV_DS.docx": "30eb",
	"./avatars/avatar2.png": "096f",
	"./avatars/avatar3.png": "5483",
	"./avatars/avatar4.png": "b009",
	"./avatars/avatar5.png": "b715",
	"./avatars/avatar6.png": "ea43",
	"./avatars/avatar7.png": "375c",
	"./avatars/avatar8.png": "62a8",
	"./avatars/avatar9.png": "9880",
	"./bd_logo.png": "5608",
	"./bd_logo_black.png": "be15",
	"./config.zip": "6f05",
	"./data-1732039531515.csv": "1dae",
	"./db-placeholder.png": "b875",
	"./gricon1.png": "6519",
	"./gricon2.png": "efe1",
	"./gricon3.png": "cb6f",
	"./gricon4.png": "dd9a",
	"./image.png": "e429",
	"./logo.png": "cf05",
	"./logo1.png": "534f",
	"./logo2.png": "5fbe",
	"./pdf_excel.png": "8ebe",
	"./remap_logo2.png": "e6e8",
	"./response_1731918460194": "2913",
	"./response_1731918460194.json": "2913"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";